import type { ReactElement, SVGProps } from "react";

/** Chevron that flips between pointing down (closed) and up (open). */
export function ChevronToggleIcon({
  open,
  ...props
}: SVGProps<SVGSVGElement> & { open: boolean }): ReactElement {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points={open ? "18 15 12 9 6 15" : "6 9 12 15 18 9"} />
    </svg>
  );
}
